import apiClient from "../core/HttpClient";
import { ShoppingCategory } from "../models";

export default class ShoppingCategoryService {
  url = "/ShoppingCategories";

  public async getShoppingCategories(): Promise<ShoppingCategory[]> {
    return apiClient.get(this.url).then((res) => res.data);
  }

  public async getShoppingCategoryById(id: number): Promise<ShoppingCategory> {
    return apiClient.get(`${this.url}/${id}`).then((res) => res.data);
  }

  public async createShoppingCategory(shoppingCategory: ShoppingCategory) {
    return apiClient.post(this.url, { name: shoppingCategory.name });
  }

  public async updateShoppingCategory(shoppingCategory: ShoppingCategory) {
    return apiClient.put(`${this.url}/${shoppingCategory.id}`, {
      id: shoppingCategory.id,
      name: shoppingCategory.name,
    });
  }

  public async deleteShoppingCategory(id: number) {
    return apiClient.delete(`${this.url}/${id}`);
  }
}
